import { isEmpty } from 'lodash';

/**
 * Filter users based on selected unions
 * @param {Array} selectedUnions - Array of selected union objects from filter state
 * @returns {Function} A filter function that returns true for users with matching unions
 */
export const filterUserWithUnions = (selectedUnions) => {
  // If no unions are selected, return all users
  if (!selectedUnions || !Array.isArray(selectedUnions) || selectedUnions.length === 0) {
    return () => true;
  }

  return (user) => {
    // If user doesn't have selectedUnions data, skip them
    if (!user || !user.selectedUnions || !Array.isArray(user.selectedUnions) || user.selectedUnions.length === 0) {
      return false;
    }

    // Extract union names from the filter for easier matching
    const selectedUnionNames = selectedUnions.map(union => 
      typeof union === 'string' ? union : union.name
    );

    // Check if any of the user's unions match the selected unions
    return user.selectedUnions.some(userUnion => {
      // Handle both string values and object values
      const unionName = typeof userUnion === 'string' ? userUnion : userUnion.name;
      return selectedUnionNames.includes(unionName);
    });
  };
};

export default filterUserWithUnions;
